import { MdExpandMore } from 'react-icons/md';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';

import { TableGrid } from '../../TableGrid';

const CategoryAccordionTable = ({ category, expanded, onToggle, ...tableGridProps }) => (
    <Accordion id={`category-${category.category_id}`} expanded={expanded} onChange={onToggle}>
        <AccordionSummary
            sx={{
                backgroundColor: '#efefef',
            }}
            expandIcon={<MdExpandMore />}
        >
            {category.display_name}
        </AccordionSummary>
        <AccordionDetails sx={{ padding: '8px !important' }}>
            <Box
                id={`assetCards-${category.category_id}`}
                sx={{
                    overflow: 'auto !important',
                }}
            >
                <TableGrid {...tableGridProps} categoryIds={[category.category_id]} />
            </Box>
        </AccordionDetails>
    </Accordion>
);

export { CategoryAccordionTable };
